import { call, put, takeLatest } from 'redux-saga/effects'
import {
  sendOtpFailure,
  sendOtpRequest,
  sendOtpSuccess,
  verifyOtpFailure,
  verifyOtpRequest,
  verifyOtpSuccess,
  authenticateUserRequest,
  authenticateUserSuccess,
  authenticateUserError,
  updateUserSuccess,
  updateUserError,
  updateUserRequest,
} from '../slices'
import {
  loginOrRegisterPatient,
  sendOtp,
  updateUser,
  verifyOtp,
} from '../../api'

// Worker Saga: Send OTP
function* handleSendOtp(action) {
  try {
    const response = yield call(sendOtp, action.payload)
    yield put(sendOtpSuccess(response))
  } catch (error) {
    yield put(sendOtpFailure(error.message || 'Unknown Error Occured'))
  }
}

// Worker Saga: Verify OTP
function* handleVerifyOtp(action) {
  try {
    const response = yield call(verifyOtp, action.payload)
    yield put(verifyOtpSuccess(response))
  } catch (error) {
    yield put(verifyOtpFailure(error.message || 'Unknown Error Occured'))
  }
}

// Worker Saga: handle authenticate user
function* handleAuthenticateUser(action) {
  try {
    const response = yield call(loginOrRegisterPatient, action.payload)
    yield put(authenticateUserSuccess(response))
  } catch (error) {
    yield put(authenticateUserError(error.message || 'Unknown Error Occured'))
  }
}

// Worker Saga: handle update user
function* handleUpdateUser(action) {
  try {
    const response = yield call(updateUser, action.payload)
    yield put(updateUserSuccess(response))
  } catch (error) {
    yield put(updateUserError(error.message || 'Unknown Error Occured'))
  }
}

// Watcher Saga
function* authSaga() {
  yield takeLatest(sendOtpRequest.type, handleSendOtp)
  yield takeLatest(verifyOtpRequest.type, handleVerifyOtp)
  yield takeLatest(authenticateUserRequest.type, handleAuthenticateUser)
  yield takeLatest(updateUserRequest.type, handleUpdateUser)
}

export default authSaga
